export default __webpack_public_path__ + "static/media/for-business-kit-image.54eb5a6d.png";